import { inject, Injectable } from '@angular/core';
import { AppStateCacheService } from '@lentau/core/app-state-cache/shared/app-state-cache.service';
import { AppCacheMPKKey, MPKeys } from '@lentau/mpk/shared/constants';
import { isRemi, isSuperJam, isUtk } from '@lentau/ui-kit/core/helpers/isBrand.helper';
import { BrowserApiSupportService } from '@lentau/ui-kit/core/services/browser-api-support/browser-api-support.service';

@Injectable({
  providedIn: 'root',
})
export class CacheMPKService {
  private appStateCacheService: AppStateCacheService = inject(AppStateCacheService);
  private browserApiSupportService: BrowserApiSupportService = inject(BrowserApiSupportService);

  // Для SSR и Утконоса МПК как для Доставки и Б2С
  // Для клиента сперва проверяем кэш и если нет - берём МПК как для Самовывоза и Б2С
  public getInitDeliveryMode(): MPKeys {
    if (this.browserApiSupportService.isSearchBot() || isUtk()) {
      if (isSuperJam()) {
        return MPKeys.SUPERJAM_B2C_DELIVERY;
      }
      if (isRemi()) {
        return MPKeys.REMI_B2C_DELIVERY;
      }
      return MPKeys.LENTA_B2C_DELIVERY;
    }

    let mpk: MPKeys = this.appStateCacheService.get(AppCacheMPKKey);

    // Если кеш пустой, то записать в кеш дефолтное значение
    if (!mpk) {
      if (isSuperJam()) {
        mpk = MPKeys.SUPERJAM_B2C_DELIVERY;
      } else if (isRemi()) {
        mpk = MPKeys.REMI_B2C_DELIVERY;
      } else {
        mpk = MPKeys.LENTA_B2C_PICKUP;
      }
      this.appStateCacheService.set(AppCacheMPKKey, mpk);
    }

    return mpk;
  }

  public updateCacheMPK(mpk: MPKeys): void {
    const currentMPK: MPKeys = this.appStateCacheService.get(AppCacheMPKKey);

    if (!currentMPK || currentMPK !== mpk) {
      this.appStateCacheService.set(AppCacheMPKKey, mpk);
    }
  }
}
